import { render } from "./Article.vue?vue&type=template&id=38401098&scoped=true&ts=true"
import script from "./Article.vue?vue&type=script&lang=ts"
export * from "./Article.vue?vue&type=script&lang=ts"

import "./Article.vue?vue&type=style&index=0&id=38401098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38401098"]])

export default __exports__